// Pollyfill pour array.find
if (!Array.prototype.find) {
	Array.prototype.find = function(predicate) {
		if (this === null) {
			throw new TypeError('Array.prototype.find a été appelé sur null ou undefined');
		}

		if (typeof predicate !== 'function') {
			throw new TypeError('predicate doit être une fonction');
		}

		const list = Object(this);
		const length = list.length >>> 0;
		const thisArg = arguments[1];
		let value;

		for (let i = 0; i < length; i++) {
			value = list[i];
			if (predicate.call(thisArg, value, i, list)) {
				return value;
			}
		}

		return undefined;
	};
}
